"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFontSize = getFontSize;

var _fontSizeSelector = require("../fontSizeSelector");

function getFontSize(type, size) {
  return function (props) {
    return (0, _fontSizeSelector.fontSizeSelector)(props, type, size);
  };
}